// src/MathTools/LinearInequalityPlot.js  (v1.1)
import CoordinatePlane from "./CoordinatePlane";

export default function LinearInequalityPlot({
  m = 1,
  b = 0,
  op = ">",
  dashed = null, // auto if null
  width = 320,
  height = 220,
  shadeColor = "rgba(33,150,243,0.15)",
  showGrid = false,
  showAxes = false,
  xDomain = [-10, 10],
  ...restProps
}) {
  /* ────── derive y‑domain so the line crosses the box ────── */
  const yAtLeft = m * xDomain[0] + b;
  const yAtRight = m * xDomain[1] + b;
  const yMinLine = Math.min(yAtLeft, yAtRight);
  const yMaxLine = Math.max(yAtLeft, yAtRight);

  // pad by 10 % so the line isn't flush to the border
  const pad = 0.1 * (yMaxLine - yMinLine || 1);
  const yDomain = [yMinLine - pad, yMaxLine + pad];

  /* strict vs inclusive boundary */
  const isStrict = op === ">" || op === "<";
  const dash = dashed !== null ? dashed : isStrict ? "4 4" : null;

  return (
    <CoordinatePlane
  width={width}
  height={height}
  xDomain={xDomain}
  yDomain={yDomain} // <<-- 新增
  showGrid={showGrid}
  showAxes={showAxes}
  disablePlot={true}
  lines={[
    { 
      start: [xDomain[0], yAtLeft], 
      end: [xDomain[1], yAtRight], 
      color: "blue", 
      label: "y = mx + b",
      dash: dash // <<-- 新增
    }
  ]}
  // 可以往後新增 props 處理陰影
/>

  );
}
